import { useId, useState } from 'react'
import AdvancedFilters, { ADVANCED_FILTERS_TRIGGER_ID } from './AdvancedFilters'
import AdvancedFiltersTrigger from './AdvancedFiltersTrigger'
import { useAdvancedFilters } from './filterUrl'
import { countVisibleFilters } from './presetFilters'

// The trigger + popover pair every listing page needs. Advanced filters live in
// the URL (useAdvancedFilters), so this reads and writes the same state as the
// page's chips row and list query without anything being passed between them.
// Presets stay page-owned: pass them through when the page has defaults.
// `hiddenFields` drops fields from the popover's field picker for pages where
// one cannot mean anything -- see AvailableCarsHeader.
//
// Each control gives its trigger its own id: the popover anchors by id, and an
// id shared by several triggers resolves to the first one in the document. On
// detail pages that keep visited tabs mounted (e.g. the car page's hidden
// Rentals tab) that first match is an invisible trigger, which put the popover
// at the top of the page. useId's colons are stripped -- they aren't valid in
// the `#id` selector the popover and its click-outside check use.
export default function AdvancedFiltersControl({ entity, context = null, presets, setPresets, defaultPresets, hiddenFields, compact = true }) {
    const [isOpen, setIsOpen] = useState(false)
    const triggerId = `${ADVANCED_FILTERS_TRIGGER_ID}-${useId().replace(/:/g, '')}`
    const [advancedFilters, setAdvancedFilters] = useAdvancedFilters()
    return (
        <>
            <AdvancedFiltersTrigger
                compact={compact}
                id={triggerId}
                count={countVisibleFilters(presets, advancedFilters)}
                onClick={() => setIsOpen(!isOpen)}
            />
            {isOpen && (
                <AdvancedFilters
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    entity={entity}
                    context={context}
                    activeFilters={advancedFilters}
                    onApply={(newFilters) => setAdvancedFilters(newFilters)}
                    presets={presets}
                    onPresetsChange={setPresets}
                    defaultPresets={defaultPresets}
                    hiddenFields={hiddenFields}
                    triggerId={triggerId}
                />
            )}
        </>
    )
}
